var React = require('react');

function DazzleSun (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 3V4M12 20V21M4 12H3M6.31412 6.31412L5.5 5.5M17.6859 6.31412L18.5 5.5M6.31412 17.69L5.5 18.5001M17.6859 17.69L18.5 18.5001M21 12H20M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

DazzleSun.defaultProps = {"width":"80px","height":"80px","viewBox":"0 0 24 24","fill":"none"};

module.exports = DazzleSun;

DazzleSun.default = DazzleSun;
